var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blood-oxygen-unit"},[_c('div',{staticClass:"blood-oxygen-unit-left"},[_c('p',[_vm._v(_vm._s(_vm.title)+"：")]),_c('input',{staticClass:"blood-oxygen-unit-left-value",domProps:{"value":_vm.value}})]),_c('p',{staticClass:"blood-oxygen-unit-unit"},[_vm._v(_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }